/**
 * Thrown for any non-2xx response from the SlickPay API, and for transport
 * failures (offline, DNS, CORS). Carries the raw body so callers can inspect
 * SlickPay's own validation messages instead of guessing from a status code.
 */
export class SlickPayError extends Error {
  constructor(message, { status = null, body = null, code = null, cause } = {}) {
    super(message, cause ? { cause } : undefined);
    this.name = "SlickPayError";
    /** HTTP status, or null for transport-level failures. */
    this.status = status;
    /** Parsed response body (object) or raw text, when there was one. */
    this.body = body;
    /** Short machine-readable code: "network" | "http" | "config" | "response". */
    this.code = code;
  }

  /**
   * SlickPay returns validation errors as `{ errors: { field: [msg, ...] } }`.
   * Flattens that into a single readable string when present.
   */
  get validationMessages() {
    const errors = this.body?.errors;
    if (!errors || typeof errors !== "object") return [];
    return Object.entries(errors).flatMap(([field, messages]) =>
      (Array.isArray(messages) ? messages : [messages]).map((m) => `${field}: ${m}`)
    );
  }
}
